export default __webpack_public_path__ + "static/media/status-error.d9a7fbf0.svg";